
import FilterSliderComponent from "~/components/filters/FilterSliderComponent.vue";

export default {
  name: 'SquareFilter',
  components: {
    FilterSliderComponent,
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    selected: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  emits: [
    'change',
  ],
  computed: {
    optionMinimal: function () {
      return this.item?.minSquare || 0
    },
    optionMaximal: function () {
      return this.item?.maxSquare || 100
    },

    selectedPricesMin: function () {

      const findMin = Object.keys(this.selected.plosad || {})?.[0]?.split(':')?.[0] || this.item?.selectedSquares?.[0] || this.item.minSquare || 0
      return Number(findMin)
    },
    selectedPricesMax: function () {
      const findMax = Object.keys(this.selected.plosad || {})?.[0]?.split(':')?.[1] || this.item?.selectedSquares?.[1] || this.item.maxSquare || 0
      return Number(findMax)
    },
  },
  methods: {
    changeRange: function ({ range }) {
      this.$emit("change", range);
    },
  },
}
